// Formatting shared by the two build & submit dialogs (Audience+ and Ads Manager).

/**
 * A built artifact's size, for a person deciding whether it can ship.
 *
 * An applovin SIP is one self-contained html with every image inlined, so the
 * number is the whole creative — and the networks cap it. Rounded the way that
 * decision is made: nobody cares about the bytes, they care about the megabytes.
 */
export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return null;
  if (bytes < 1024) return `${bytes} B`;

  const kb = bytes / 1024;
  return kb < 1024 ? `${Math.round(kb)} KB` : `${(kb / 1024).toFixed(1)} MB`;
}

/**
 * A manifest timestamp, as a person reads it.
 *
 * The stamps are ISO strings written by the container. "Delivered on
 * 2026-08-04T14:02:11Z" is a machine talking; the point of showing it at all is
 * for someone to think "that was this morning".
 */
export function formatStamp(iso) {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return String(iso);
  return date.toLocaleString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
